Backbone.Radio.channel('media').reply('setupMedia',function(options){
	var preferredAsset = options.asset;
	var target = options.target;
	var playlist = options.playlist;
	var program = options.program;
	
	if($('#'+target).length ===0){ return; }
	
	var files = JSON.parse(preferredAsset.files);
    var sources = [];
	var htm;
    
    /* If there are passport urls, use those; The public ones are probably 410 bc they expired. */
    files = (files.all_members)?files.all_members:files.public;
	var options = {
		"controls": true,
		"preload": "metadata",
		"controlBar": {
			skipButtons: {
				backward: 10
			}
		}
	}

    //sometimes a single return is just an object, not an array (see radio)
    if(!Array.isArray(files)){ files = [files]; }

    _.each(files,function(u){
        var type;
        if(u.profile){
		    if(u.profile.includes("mp3")){
		        type = "audio/mp3"
				options.audioOnlyMode = true;
				htm += 	"<style>" 
				htm += 		".player-dimensions { width: 100%; height: 40px}"
				htm += 		".vjs-control-bar { height: 40px !important; padding-top: 5px !important; background-color: #004f71 !important;}"
				htm += 		".videoAdUiAttribution { margin-bottom: 1.4rem !important; }"
				htm += 	"</style>"
		    }
			if (u.profile.includes("mp4")) {
				options.aspectRatio = u.profile.split('-')[1].split('x').join(":")
				type = "video/mp4";
				htm += 	"<style>" 
				htm += 		".player-dimensions { width: 100%;}"
				htm += 		".vjs-control-bar { background-color: #004f71 !important;}"
				htm += 		".videoAdUiAttribution { margin-bottom: 1.4rem !important; }"
				htm += 	"</style>"
			}
        }
        var s = { src: u.url }
        if(type) s.type = type;
        if(u.profile) s.label=u.profile;
        sources.push(s)
    })  
    var config = {};

    // If a show is baking ads into the mp3 itself, don't bother with a preroll PT#163255457
	var imaOptions;
    if(program && program.slug==="albumoftheweek"){
		imaOptions = {
			adTagUrl: ''
		};
    } else {
		imaOptions = {
			adTagUrl: 'http://pubads.g.doubleclick.net/gampad/ads?sz=640x480&iu=/3405737/Audio_General&ciu_szs&impl=s&gdfp_req=1&env=vp&output=xml_vast2&unviewed_position_start=1&url=[referrer_url]&correlator=[timestamp]'
		};
	}

	config.playlist=[{
		sources	 : sources
	}]
	
    if(preferredAsset.slug){ config.playlist[0].mediaid = preferredAsset.slug; } 
	
	//but sometimes we have a ton of episodes that we want to present as a playlist
	if(playlist){
		
		_.each(playlist,function(asset){
			if(asset.title === preferredAsset.title){ return; }
			
			var aSources = [];
			var f = JSON.parse(asset.files);
			_.each(f,function(u){
				var type;
		        if(u.profile){
				    if(u.profile === "mp3"){
				        type = "audio/mp3"
				    }
		        }
				var s = { src: u.url };
				if(type) s.type = type;	
				if(u.profile) s.label=u.profile;
				aSources.push(s);
			})		
			var c = {
				sources:aSources
			};
			config.playlist.push(c);
		})
	}

	var player = videojs("player", options, () => {
		console.log("this", this);
		player.log('Videojs player ready')
		player.playlist(config.playlist)
	})

	/*	
	 *	On page load, the first item in a playlist is loaded with the preroll. 
	 *	This prevents google ima from trying to request another ad while this playlist item is being played for the first time. 
	 *	After the initial preroll is over, then manually load the ad to this playlist index
	 */
	var isAdLoaded = true; 

	player.ima(imaOptions);

	$("#tmpl-show-radio-episode").append(htm)


	player.on("adsready", function(response) {
		player.ima.addEventListener(google.ima.AdEvent.Type.COMPLETE, function(){
			if (player.playlist.currentIndex() === 0) {
				// Initial preloaded ad has completed for first indexed playlist
				isAdLoaded = false;
			}
			$(".btn.btn-sm")
			.removeAttr("disabled")
			.removeClass("stop paused")
			.addClass("play")
			.html("Play")

			$('button[data-index="'+player.playlist.currentIndex()+'"]')
			.removeClass("play")
			.addClass("stop")
			.html("Stop")
						
			var styles = {
				color: "#727679",
				padding: "0",
				marginTop: "1rem",
			};
			$("#playlistContainer").css(styles)
		  });

		player.ima.addEventListener(google.ima.AdEvent.Type.STARTED, function(event) {
			$(".btn.btn-sm") // Selecting ".btn btn-sm" class instead of button div to prevent jQuery from changing other buttons on the page (such as View Show Archive)
			.attr("disabled", "disabled")
			.html("Ad Break");

			var styles = {
				color: "#DCDAD1",
				padding: "2px",
				margin: "0 0 0 0",
			};
			$("#playlistContainer").css(styles)
		})
	})

    player.on('ready',function(e){
		Backbone.Radio.channel('media').reply('play:firstPlaylistItem',function(index){
			console.log('play:firstPlaylistItem')
			if (typeof google != "undefined" && player.playlist.currentIndex() != 0) {
				player.ima.changeAdTag(imaOptions.adTagUrl);
				player.ima.requestAds();	
			}

			player.playlist.first();

			// Prevents DOMException - The play() request was interrupted error
			var playPromise = player.play();

			if (playPromise !== undefined) {
				playPromise.then(_ => {
				  // Automatic playback started!
				  // Show playing UI.
				  // We can now safely pause video...
				})
				.catch(error => {
				  // Auto-play was prevented
				  // Show paused UI.
				});
			}
		})

	    Backbone.Radio.channel('media').reply('play:playlistItem',function(index){
			if (typeof google != "undefined") {
				player.ima.changeAdTag(imaOptions.adTagUrl);
				player.ima.requestAds();	
			}

			/* 
			Videojs does not have a function that lets you select a playlist item based on index like jwPlayer does. 
			Therefore we must iterate through the playlist
			*/
			player.playlist.first();
			while(player.playlist.currentIndex() !== +index) {
				player.playlist.next();
			}
			
			// Prevents DOMException - The play() request was interrupted error
			var playPromise = player.play();
 
			if (playPromise !== undefined) {
			  playPromise.then(_ => {
				// Automatic playback started!
				// Show playing UI.
				// We can now safely pause video...
			  })
			  .catch(error => {
				// Auto-play was prevented
				// Show paused UI.
			  });
			}
		})
		
		Backbone.Radio.channel('media').reply('pause:playlistItem',function(){
			player.pause();
		})
		
		Backbone.Radio.channel('media').reply('resume:playlistItem',function(){
			player.play();		
		})
	})
	
	player.on('pause', function(){
		gtag('event', 'pause')
		$(".btn.btn-sm")
		.addClass("play")
		.removeClass("stop paused")
		.html("Play")

		$('button[data-index="'+player.playlist.currentIndex()+'"]')
		.addClass("paused")
		.html("Paused")
	})	
	
	player.on('play',function(){
		gtag('event', 'play')
		$(".btn.btn-sm")
		.addClass("play")
		.removeClass("stop paused")
		.html("Play")

		$('button[data-index="'+player.playlist.currentIndex()+'"]')
		.addClass("stop")
		.removeClass("play paused")
		.html("Stop")

		$('.rowDiv').removeClass('isPlaying');
		$('.rowDiv[data-index="'+player.playlist.currentIndex()+'"]').addClass('isPlaying');
		console.log("dataLayer", dataLayer)
		console.log("google object", google)
		console.log("window.dataLayer", window.dataLayer)
    })

	player.on('ended', function() {
		gtag('event', 'ended')
		//Reset active playlist button
		$(".btn.btn-sm")
		.removeClass("paused")
		.addClass("play")

		// Request another ad if we're not in the last playlist index
		if (player.playlist.currentIndex() !== player.playlist.lastIndex()) {
			if(typeof google != "undefined") {
				player.ima.changeAdTag(imaOptions.adTagUrl);
				player.ima.requestAds();
			}
			player.playlist.next();

			// Prevents DOMException - The play() request was interrupted error
			var playPromise = player.play();

			if (playPromise !== undefined) {
				playPromise.then(_ => {
				  // Automatic playback started!
				  // Show playing UI.
				  // We can now safely pause video...
				})
				.catch(error => {
				  // Auto-play was prevented
				  // Show paused UI.
				});
			}
		}
	})
	player.on('seeked', function(){
		gtag('event', 'seeked')
	})
	player.on('waiting', function(){
		gtag('event', 'buffer')
	})
});